import { useSelector } from 'react-redux';
import { getPostsFeedType } from 'redux/selectors';
import { useCreateDispatches } from 'helpers/hooks';
import {
	getClearedServiceState,
	isServicePostState,
} from '../utils/servicePostUtils';
import HelpOutline from '@mui/icons-material/HelpOutline';
import {
	RadioGroup,
	Radio,
	FormControl,
	FormControlLabel,
	Tooltip,
} from '@mui/material';
import styles from '../editPost.module.css';

export default function SwitcherRadios({
	state,
	setState,
	setActiveServiceCategoryIndex,
}) {
	const { setFeedType } = useCreateDispatches();
	const feedType = useSelector(getPostsFeedType);

	const onChange = ({ target }) => {
		const nextFeedType = target?.value;
		setFeedType(nextFeedType);
		if (nextFeedType === 'timeline') {
			setState((currentState) =>
				getClearedServiceState(currentState.change)
			);
			setActiveServiceCategoryIndex(null);
		}
	};

	let postType;
	if (feedType === 'services' || isServicePostState(state)) {
		postType = 'services';
	} else {
		postType = 'timeline';
	}

	return (
		<FormControl className={styles.switcherRadiosRoot}>
			<div
				id='demo-radio-buttons-group-label'
				className={styles.switcherRadiosLabel}>
				Is this a service post?
				<Tooltip
					title='Service posts help record important information about the services your child
							receives while in care.'>
					<HelpOutline className={styles.switcherRadiosHelpIcon} />
				</Tooltip>
			</div>
			<RadioGroup
				className={styles.switcherRadiosGroup}
				aria-labelledby='demo-radio-buttons-group-label'
				value={postType}
				onChange={onChange}
				name='radio-buttons-group'>
				<FormControlLabel value='services' control={<Radio />} label='Yes' />
				<FormControlLabel value='timeline' control={<Radio />} label='No' />
			</RadioGroup>
		</FormControl>
	);
}
